import './login.scss';

export function LoginController(
    $scope,
    $location,
    $timeout
){
    'ngInject';

    $scope.logo = "VMS_Logo.png";
    // Current Year
    $scope.currentYear = new Date().getFullYear();    
    
    // Data form
    $timeout(function () {
        $scope.user = { username: $('#UserName').val(), password: $('#Password').val(), id: $('#BusinessID').val() };
    },5000)
    $scope.master = {};

    $scope.update = function (user) {
        $scope.master = angular.copy(user);
        console.log($scope.master);
    };

    // Single sign in
    $scope.singleSignIn = $location.url();

    if ($scope.singleSignIn == "/#singlelogin") {
        $scope.singleSignInBtn = true;
    } else {
        $scope.singleSignInBtn = false;
    }
    // DONE
//Shivakumar | UP2018-2393 | 22-July-2020 | Get cookies details for Remember Password
    $scope.getCookies = function () {
        $scope.user = { username: get_cookie('UserName'), password: get_cookie('Password'), id: get_cookie('BusinessID') };
    };
    $scope.getCookies();
    function get_cookie(name) {
        var output;
        var encrypted_cookie = document.cookie.match(new RegExp(name + '=([^;]+)'));
        if (encrypted_cookie != null & encrypted_cookie != "") {
            $.ajax({
                type: "POST",
                url: 'login.aspx/Decrypt_Cookie',
                async: false,
                contentType: 'application/json;charset=utf-8',
                data: JSON.stringify({
                    'cookie_name': encrypted_cookie[1]
                }),
                dataType: 'JSON',
                success: function (result) {
                    output = result.d;
                }
            });
            return output;
        }

    }
}


// WEBPACK FOOTER //
// ./Angular_Code/app/Login/login.controller.js